export default {
    startingSoon: 'Starting soon',
    now: 'Now'
}
